<footer class="app-footer">
  <div class="footer-container">
    <div class="footer-main">
      <div class="footer-brand">
        <a (click)="navigateWithScroll('/home')" class="footer-logo">
          <span class="footer-logo-text">Markado</span>
        </a>
        <p class="footer-tagline">
          The trusted marketplace for cars, homes, electronics and more
        </p>
        <div class="footer-app-badges">
          <a href="/coming-soon" class="app-badge">
            <svg viewBox="0 0 24 24" class="app-badge-icon">
              <path d="M12 18.178l-4.62-1.256-.328-3.544h5.9l.328 4.8z"></path>
              <path d="M12 22L3 18l-1-13h20l-1 13-9 4z"></path>
              <path d="M2 5h20"></path>
              <path d="M16 2H8"></path>
            </svg>
            <span>Download on App Store</span>
          </a>
          <a href="/coming-soon" class="app-badge">
            <svg viewBox="0 0 24 24" class="app-badge-icon">
              <path d="M3 8l7.89 5.26a2 2 0 0 0 2.22 0L21 8"></path>
              <path
                d="M5 19h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2z"
              ></path>
            </svg>
            <span>Get it on Google Play</span>
          </a>
        </div>
      </div>

      <div class="footer-links">
        <div class="footer-links-column">
          <h4 class="footer-links-title">Categories</h4>
          <ul class="footer-links-list">
            <li>
              <a (click)="navigateWithScroll('/search/vehicles')">Vehicles</a>
            </li>
            <li>
              <a (click)="navigateWithScroll('/search/real-estate')"
                >Real Estate</a
              >
            </li>
            <li>
              <a (click)="navigateWithScroll('/search/marketplace')"
                >Marketplace</a
              >
            </li>
            <li>
              <a (click)="navigateWithScroll('/search/jobs')">Jobs</a>
            </li>
          </ul>
        </div>

        <div class="footer-links-column">
          <h4 class="footer-links-title">Sell on Markado</h4>
          <ul class="footer-links-list">
            <li><a (click)="navigateWithScroll('/sell')">Sell</a></li>
            <li>
              <a (click)="navigateWithScroll('/profile')">Seller Dashboard</a>
            </li>
            <li>
              <a (click)="navigateWithScroll('/fees-payments')"
                >Fees & Payments</a
              >
            </li>
            <li>
              <a (click)="navigateWithScroll('/tips')">Tips for Success</a>
            </li>
          </ul>
        </div>

        <div class="footer-links-column">
          <h4 class="footer-links-title">Help & Contact</h4>
          <ul class="footer-links-list">
            <li>
              <a (click)="navigateWithScroll('/help-center')">Help Center</a>
            </li>
            <li>
              <a (click)="navigateWithScroll('/contact-us')">Contact Us</a>
            </li>
          </ul>
        </div>

        <div class="footer-links-column">
          <h4 class="footer-links-title">More</h4>
          <ul class="footer-links-list">
            <li><a (click)="navigateWithScroll('/about-us')">About Us</a></li>
            <li><a (click)="navigateWithScroll('/careers')">Careers</a></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="footer-social">
        <a
          href="https://x.com/typtron"
          target="_blank"
          rel="noopener noreferrer"
          class="social-link"
        >
          <svg
            class="social-icon"
            width="24"
            height="24"
            viewBox="0 0 1200 1227"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
              fill="currentColor"
            />
          </svg>
        </a>

        <a
          href="https://instagram.com/typtron"
          target="_blank"
          rel="noopener noreferrer"
          class="social-link"
        >
          <svg viewBox="0 0 24 24" class="social-icon">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
          </svg>
        </a>

        <a
          href="https://linkedin.com/company/typtron"
          target="_blank"
          rel="noopener noreferrer"
          class="social-link"
        >
          <svg
            class="social-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
            ></path>
            <rect x="2" y="9" width="4" height="12"></rect>
            <circle cx="4" cy="4" r="2"></circle>
          </svg>
        </a>
      </div>

      <div class="footer-legal">
        <a (click)="navigateWithScroll('/privacy-policy')">Privacy Policy</a>
        <span class="legal-separator">•</span>
        <a (click)="navigateWithScroll('/terms-of-service')"
          >Terms of Service</a
        >
      </div>

      <div class="footer-copyright">
        <p>© {{ currentYear }} Developed by Typtron. All rights reserved.</p>
      </div>
    </div>
  </div>
</footer>
